import React, { useEffect } from 'react'
import ListComments from '../Utils/ListComments'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { getAllCommentsOfPostAPI, getSpecificPostComments } from '../../RTK/Slice/SpecificPost/SpecificPostSlice'
import { useParams } from 'react-router-dom'

const SpecificPostComments = () => {

  // For Access Post Id
  const {postId} = useParams() ; 
  
  // for get token 
  const token = useSelector(getToken) ;
  
  // For Dispatch Action
  const dispatch = useDispatch() ; 

  // For Access Comments Data
  const {comments , statusOfComments} = useSelector(getSpecificPostComments); 

  // for get active token 
  const userToken = useSelector(getActiveToken) ; 

  // For get all comments
  useEffect(()=>{
    dispatch(getAllCommentsOfPostAPI({token , userToken , postId}))
  }, [dispatch])

  return (
    <div>
        <ListComments comments={comments} statusOfComments={statusOfComments}  />
    </div>
  )
}

export default SpecificPostComments
